'use client'

import { CSSProperties } from 'react'

import { Checkbox, Table } from '@radix-ui/themes'

import { useTableContext, useTableStoreFn } from '../context/table-context'
import { TTableStore } from '../types/table-store'

type TProps<T> = {
    row: T
    style?: CSSProperties
}

const TableRowSelectBox = <T,>({ row, style }: TProps<T>) => {
    const { store, id } = useTableContext<T>()
    const selectedRow = useTableStoreFn((store: TTableStore<T>) =>
        store.selectedRows.get(row[id] as string | number)
    )

    return (
        <Table.Cell className="table__selectable-cell fixed" style={style}>
            <Checkbox
                checked={selectedRow !== undefined}
                onCheckedChange={() => {
                    const { selectedRows } = store.get()
                    const updated = new Map(selectedRows)
                    const key = row[id] as string | number
                    if (updated.has(key))
                        updated.delete(key)
                    else
                        updated.set(key, row)

                    store.update({ selectedRows: updated })
                }}
            />
        </Table.Cell>
    )
}

export default TableRowSelectBox
